import { Outlet, Navigate } from "react-router-dom";
import { getItemInLocalStorage } from "../services/localStorage";

const ProtectedRoute = () => {
  const token = getItemInLocalStorage("idToken");
  const loggedIn = getItemInLocalStorage("loggedIn") === "yes";

  return token && loggedIn ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
